import { useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import SavedSearchList from "./SavedSearchList";
import SearchBar from "../common/header/SearchBar";
import { trackButtonClick } from "@/utils/analytics";
import { markInternalNavigation } from "@/utils/attributionCapture";
import { fetchRecentSearch } from "@/redux/SRP/recentSearchSlice";
import { fetchSavedSearch } from "@/redux/SRP/savedSearchSlice";

const TAB_TYPES = {
  RESIDENTIAL: "residential",
  COMMERCIAL: "commercial",
  SELL: "sell",
};

const HeroFilter = (data) => {
  const cmsData = data.data;
  const user = useSelector((state) => state.user);

  const [activeTab, setActiveTab] = useState(TAB_TYPES.RESIDENTIAL);
  const userEmailId = useSelector((state) => state.user?.user?.userEmailId);
  const dispatch = useDispatch();

  const handleTabClick = (key) => {
    if (key === TAB_TYPES.COMMERCIAL) {
      markInternalNavigation();
      window.open("/commercial", "_blank");
    } else if (key === TAB_TYPES.SELL) {
      window.open("/sellahomeinanonlineauction", "_blank");
    } else {
      setActiveTab(key);
    }

    trackButtonClick({
      eventName: "hero_section_click",
      eventParams: { tab: key },
      eventCategory: "Home Page 2.0",
      eventSource: `${key} Tab click`,
    });
  };

  useEffect(() => {
    dispatch(fetchRecentSearch());
  }, [dispatch, userEmailId]);

  useEffect(() => {
    dispatch(fetchSavedSearch({ emailId: userEmailId }));
  }, [dispatch, userEmailId]);

  return (
    <div className="home_content">
      <div className="home-text text-center home-hero-text">
        <h2 className="home-header-title">
          {user.userName
            ? `Welcome back, ${user.userName}!`
            : cmsData?.newBanner?.title || "Find Your Dream Property"}
        </h2>
      </div>

      <div className="home-text text-center d-flex justify-content-center home-hero-tab">
        <div className="custom-home-tabs" role="tablist">
          <button
            id="hero-tab-residential"
            className={`custom-home-tab ${
              activeTab === TAB_TYPES.RESIDENTIAL ? "active" : ""
            }`}
            onClick={() => handleTabClick(TAB_TYPES.RESIDENTIAL)}
            role="tab"
            aria-selected={activeTab === TAB_TYPES.RESIDENTIAL}
            aria-current={
              activeTab === TAB_TYPES.RESIDENTIAL ? "page" : undefined
            }
            tabIndex={activeTab === TAB_TYPES.RESIDENTIAL ? "0" : "-1"}
          >
            <span className="custom-home-tab-text">Buy Residential</span>
          </button>
          <button
            id="hero-tab-commercial"
            className="custom-home-tab"
            onClick={() => handleTabClick(TAB_TYPES.COMMERCIAL)}
            role="tab"
            aria-selected={activeTab === TAB_TYPES.COMMERCIAL}
            tabIndex={activeTab === TAB_TYPES.COMMERCIAL ? "0" : "-1"}
          >
            <span className="custom-home-tab-text">Buy Commercial</span>
          </button>
          <button
            id="hero-tab-sell"
            className="custom-home-tab"
            onClick={() => handleTabClick(TAB_TYPES.SELL)}
            role="tab"
            aria-selected={activeTab === TAB_TYPES.SELL}
            tabIndex={activeTab === TAB_TYPES.SELL ? "0" : "-1"}
          >
            <span className="custom-home-tab-text">Sell</span>
          </button>
        </div>
      </div>

      <div className="home_adv_srch_opt mt140">
        <div className="home1-advnc-search home7">
          <div className="h1ads_1st_list mb0 text-center search__container--home">
            <SearchBar isSearchFromHome />
          </div>
        </div>
      </div>

      {/* <div className="">
        <SavedSearchList />
      </div> */}
    </div>
  );
};

export default HeroFilter;
